<template>
  <div class="card" id="post-category-select">
    <div class="card-body">
      <div class="divide-y">
        <div class="row">
          <template v-if="isShow()">
            <h3 class="card-title title">Категория</h3>
            <span class="col-12">
              <Select :payload="{
                value: fields.val,
                items: fields.items,
                label: 'Выберите категорию',
              }" @onChangeVal="onChange"/>
            </span>
            <div class="mt-2">
              <span class="col-12" v-if="isShowChild()">
                <Select :payload="{
                  value: null,
                  items: fields.itemsChild,
                  label: 'Выберите вложенную категорию',
                }" @onChangeVal="onChangeChild"/>
              </span>
            </div>
          </template>
          <template v-else>
            <div class="mb-3">
              <div class="loader-item">
                <div class="spinner-border spinner-border-sm me-2"></div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, reactive, ref} from "vue"
import Select from "./components/select/Index"
import Api from "./services/Api"
import CatalogImage from '@/modules/catalog/services/Image'

export default defineComponent({
  name: "Category",
  emits: ['onChange'],
  components: {
    Select,
  },
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let show = ref(false)
    let showChild = ref(false)
    const fields = reactive({
      val: null,
      items: [],
      itemsChild: [],
    })

    onMounted(async () => {
      updateFields(props.payload)

      markUnshow()
      setItems(await getCategories())
      markShow()
    })

    function setItems(val) {
      fields.items = val
    }

    function updateFields(query) {
      fields.val = query.val
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    async function getCategories(query = {}) {
      let resp = await Api.categories(query)

      let items = resp.data["items"]

      const result = [];
      items.forEach(cat => {
        let image = CatalogImage.handle(cat["category_image_host"], cat["category_image_name"], 60, 60)

        result.push({
          value: cat["category_id"],
          title: cat["category_name"],
          image: image,
          path: cat["category_str_path"].replaceAll("###", "/"),
          level: cat["category_level"],
        });
      });

      return result
    }

    function isShow() {
      return show.value === true
    }

    async function onChange(value) {
      unmarkShowChild()
      await setItemsChild([])

      if (value["category_id"] === null || value["category_id"] === undefined) {
        emit("onChange", value["category_id"])
        return
      }

      let itemsChild = await getCategories({
        "start_id": value["category_id"],
      })

      if (itemsChild.length > 0) {
        await setItemsChild(itemsChild)
        markShowChild()
      }
      
      emit("onChange", value["category_id"])
    }

    async function onChangeChild(value) {
      emit("onChange", value["category_id"])
    }

    async function setItemsChild(items) {
      fields.itemsChild = items
    }

    function markShowChild() {
      showChild.value = true
    }

    function unmarkShowChild() {
      showChild.value = false
    }

    function isShowChild() {
      return showChild.value === true
    }

    return {
      isShow,
      isShowChild,
      onChange,
      onChangeChild,
      fields,
    }
  }
})
</script>
